import { render, staticRenderFns } from "./src/pages/static.html?vue&type=template&id=a6d27086&scoped=true&"
import script from "./src/pages/static.js?vue&type=script&lang=js&"
export * from "./src/pages/static.js?vue&type=script&lang=js&"
import style0 from "./src/pages/static.scss?vue&type=style&index=0&id=a6d27086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d27086",
  null
  
)

export default component.exports